/**
 * Custom tour styles matching shadcn UI Popover design
 * Uses CSS variables from the theme for consistent styling
 * Note: The project uses oklch color format, so we reference CSS variables directly
 */
export const tourStyles = {
  popover: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--popover)",
    color: "var(--popover-foreground)",
    borderRadius: "calc(var(--radius) - 2px)",
    border: "1px solid var(--border)",
    padding: "1.25rem",
    boxShadow:
      "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1), 0 0 0 1px var(--border)",
    maxWidth: "22rem",
    minWidth: "20rem",
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    transition: "all 0.3s ease-out",
  }),
  badge: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--primary)",
    color: "var(--primary-foreground)",
    borderRadius: "calc(var(--radius) - 2px)",
    fontWeight: "600",
    fontSize: "0.75rem",
    padding: "0rem 0.5rem",
    transition: "all 0.3s ease",
  }),
  controls: (base: Record<string, unknown>) => ({
    ...base,
    marginTop: "1.25rem",
    display: "flex",
    gap: "0.5rem",
    justifyContent: "center",
    paddingTop: "1rem",
    borderTop: "1px solid var(--border)",
  }),
  close: (base: Record<string, unknown>) => ({
    ...base,
    color: "var(--muted-foreground)",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "calc(var(--radius) - 2px)",
    margin: "-0.75rem",
    cursor: "pointer",
    "&:hover": {
      color: "var(--foreground)",
      backgroundColor: "var(--muted)",
    },
  }),
  dot: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--muted-foreground)",
    transition: "all 0.3s ease",
    "&.reactour__dot-active": {
      backgroundColor: "var(--primary)",
      transform: "scale(1.2)",
      boxShadow: "0 0 0 4px var(--primary)20",
    },
    "&:hover": {
      transform: "scale(1.1)",
    },
  }),
  maskArea: (base: Record<string, unknown>) => ({
    ...base,
    transition: "opacity 0.3s ease-out",
  }),
  highlightedArea: (base: Record<string, unknown>) => ({
    ...base,
    transition: "all 0.3s ease",
    boxShadow: "0 0 0 4px var(--primary) 20",
  }),
}
